module.exports = __webpack_public_path__ + "img/svv.d7fb7b38.png";